import {TextField, Autocomplete} from "@mui/material";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";


export default function InsertTemplateAcOne(props: any) {

    let {authTokens, serverIP} = useContext(AuthContext)

    const {projUID, setFoundTemplate} = props

    let qString: any = ''

    const [valuesArr, setValuesArr] = useState<any[]>([])

    return (
        <Autocomplete
            key={1}
            // value={val}
            onChange={(event, newValue) => {
                // console.log(newValue)
                if (newValue) {
                    setFoundTemplate(newValue.mapObj)
                }
            }}

            isOptionEqualToValue={(option, value) => option.value === value.value}

            onInputChange={(event, newValue) => {
                // console.log(newValue)
                // if ((isNaN(parseInt(newValue)) && newValue.length >= 2) || (!isNaN(parseInt(newValue)) && newValue.length >= 1)) {
                if (newValue && newValue.length >= 2) {
                    qString = newValue

                    fetch(`${serverIP}/featusetemplate/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + String(authTokens.access)
                        },
                        body: JSON.stringify({projUID: projUID, qString: qString}),
                    }).then(res => res.json())
                        .then((data) => {
                            if (data.length > 0) {
                                // console.log(data)
                                setValuesArr(data)
                            }
                        })
                } else {
                    setValuesArr([])
                }
            }}

            disablePortal
            handleHomeEndKeys
            autoHighlight
            forcePopupIcon={false}
            size="small"    // IMPORTANT! It is bind to the CSS class "MuiInputBase-sizeSmall"
            id="combo-box-demo"
            options={valuesArr}
            // options={valuesArr.map((option)=>option)}
            // getOptionLabel={(item) => item.label || ''}
            clearOnEscape={true}
            // sx={{width: "400px"}}
            ListboxProps={
                {style: {
                        fontSize: '0.8rem',
                        fontFamily: "'Inter', sans-serif",
                        color: 'black'
                    }
                }}

            renderInput={(params) =>
                <TextField
                    {...params}
                    // label="insert template name"
                    style={{backgroundColor: 'white'}}
                    variant="standard"
                    fullWidth
                    size="small"
                    margin="dense"
                    // InputProps={{
                    //     style: {height: 30}
                    // }}
                />}

        />
    );
}
